import { render, staticRenderFns } from "./invoice_all.vue?vue&type=template&id=fb4b5844&scoped=true"
import script from "./invoice_all.vue?vue&type=script&lang=js"
export * from "./invoice_all.vue?vue&type=script&lang=js"
import style0 from "./invoice_all.vue?vue&type=style&index=0&id=fb4b5844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4b5844",
  null
  
)

export default component.exports